import { UtilServiceV2 } from './../providers/util-service-v2';

import { AjudaPage } from '../pages/ajuda/ajuda';

import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BrowserModule } from '@angular/platform-browser';

import { NgxPaginationModule } from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';

import { CurrencyMaskModule } from "ngx-currency-mask";

import { FileUploadModule } from 'ng2-file-upload';

import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';

import { MyApp } from './app.component';
import { MenuModule } from '../components/menu-component/menu.module';
import { GestaoPCAModule } from '../pages/modulos/gestao-pca/gestao-pca.module';
import { ModulosModule } from '../pages/modulos/modulos.module';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';

import { CadastroPerguntasPage } from '../pages/cadastro-perguntas/cadastro-perguntas';

import { TiposIrregularidadesPage } from '../pages/tipos-irregularidades/tipos-irregularidades';

import { ModalAdicionarPerguntaPage } from '../pages/modais/modal-adicionar-pergunta/modal-adicionar-pergunta';
import { ModalDetalhesRolResponsaveisPage } from '../pages/modais/modal-detalhes-rol-responsaveis/modal-detalhes-rol-responsaveis';
import { ModalListaEvidenciaPage } from '../pages/modais/modal-lista-evidencia/modal-lista-evidencia';
import { ModalCriaPcaPage } from '../pages/modais/modal-cria-pca/modal-cria-pca';
import { ModalOcorrenciaPage } from '../pages/modais/modal-ocorrencia/modal-ocorrencia';
import { ModalTiposIrregularidadesPage } from '../pages/modais/modal-tipos-irregularidades/modal-tipos-irregularidades';
import { ModalCadastroPerguntasPage } from '../pages/modais/modal-cadastro-perguntas/modal-cadastro-perguntas';
import { ModalVincularArquivoPage } from '../pages/modais/modal-vincular-arquivo/modal-vincular-arquivo';
import { ModalPlanoAcaoPage } from '../pages/modais/modal-plano-acao/modal-plano-acao';
import { ModalPreVisualizarControlesInternoPage } from '../pages/modais/modal-pre-visualizacao/controles-internos/modal-pv-controles-internos';
import { ModalPreVisualizarProcessosCorrelatosPage } from '../pages/modais/modal-pre-visualizacao/processos-correlatos/modal-pv-processos-correlatos';
import { ModalProdutoContratoPage } from '../pages/modais/modal-produto-contrato/modal-produto-contrato';
import { ModalJustificativaContratoPage } from '../pages/modais/modal-justificativa-contrato/modal-justificativa-contrato';
import { ModalPreVisualizarContratosPage } from '../pages/modais/modal-pre-visualizacao/contratos/modal-pv-contratos';
import { ModalArquivosContratosPage } from '../pages/modais/modal-arquivos-contratos/modal-arquivos-contratos';
import { ModalPessoalVinculadoPage } from '../pages/modais/modal-pessoal-vinculado/modal-pessoal-vinculado';

import { ModalPreVisualizarContratosGestaoPage } from '../pages/modais/modal-pre-visualizacao/contratos-gestao/modal-pv-contratos-gestao';
import { ModalPreVisualizarMateriaisPage } from '../pages/modais/modal-pre-visualizacao/materiais/modal-pv-materiais';
import { ModalPreVisualizarOrcamentoPage } from '../pages/modais/modal-pre-visualizacao/orcamento/modal-pv-orcamento';
import { ModalPreVisualizarConveniosPage } from '../pages/modais/modal-pre-visualizacao/convenios/modal-pv-convenios';
import { ModalPreVisualizarContabilidadePage } from '../pages/modais/modal-pre-visualizacao/contabilidade/modal-pv-contabilidade';
import { ModalPreVisualizarTcePage } from '../pages/modais/modal-pre-visualizacao/tce/modal-pv-tce';

import { ModalPortariasPage } from '../pages/modais/modal-portarias/modal-portarias';
import { ModalPessoaRolPage } from '../pages/modais/modal-pessoa-rol/modal-pessoa-rol';
import { ModalCargoPage } from '../pages/modais/modal-cargo/modal-cargo';
import { ModalBensServicosPage } from '../pages/modais/modal-bens-servicos/modal-bens-servicos';

import { ModalDeterminacoesEvidenciasPage } from '../pages/modais/modal-determinacoes-evidencias/modal-determinacoes-evidencias';
import { ModalPreVisualizarMonitoramentoDecisoesPage } from '../pages/modais/modal-pre-visualizacao/monitoramento-decisoes/modal-pv-monitoramento-decisoes';
import { ModalPreVisualizarPessoalPage } from '../pages/modais/modal-pre-visualizacao/pessoal/modal-pv-pessoal';
import { ModalPreVisualizarLicitacaoPage } from '../pages/modais/modal-pre-visualizacao/licitacao/modal-pv-licitacao';

import { ModalPessoalEvidenciasPage } from '../pages/modais/modal-pessoal-evidencia/modal-pessoal-evidencia';
import { ModalPessoalTermoReferenciaPage } from '../pages/modais/modal-pessoal-termo-referencia/modal-pessoal-termo-referencia';

import { ModalAutuacaoPage } from '../pages/modais/modal-autuacao/modal-autuacao';
import { ModalEditarTextoPage } from '../pages/modais/modal-editar-texto/modal-editar-texto';
import { ModalResponsavelTcePage } from '../pages/modais/modal-responsavel-tce/modal-responsavel-tce';
import { ModalServidoresPessoalPage } from '../pages/modais/modal-servidores/modal-servidores';
import { ModalRetificacaoPage } from '../pages/modais/modal-retificacao/modal-retificacao';

import { ModalTermoReferenciaAditivoPage } from '../pages/modais/modal-termo-referencia-aditivo/modal-termo-referencia-aditivo';

import { MudaValorPergunta } from '../components/muda-valor-pergunta/muda-valor-pergunta';

import { ModalArquivosPage } from '../pages/modais/modal-arquivos/modal-arquivos';
import { ModalContasBancariasPage } from '../pages/modais/modal-contas-bancarias/modal-contas-bancarias'

import { ModalContratosPage } from '../pages/modais/modal-contratos/modal-contratos';
import { ModalContratosGestaoPage } from '../pages/modais/modal-contratos-gestao/modal-contratos-gestao';
import { ModalPagamentosPage } from '../pages/modais/modal-pagamentos/modal-pagamentos';

import { CargoService } from '../providers/cargo-service';
import { ArquivosService } from '../providers/arquivos-service';
import { CertificadoService } from '../providers/certificado-service';

import { UtilService } from '../providers/util-service';
import { AlertService } from '../providers/alert-service';
import { UsuarioService } from '../providers/usuario-service';
import { ContasBancariasService } from '../providers/contas-bancarias-service';
import { NavBarModule } from '../components/nav-bar/nav-bar.module';
import { AnaliseService } from '../providers/analise-service';
import { FileService } from '../providers/file-service';
import { ContratoService } from '../providers/contrato-service';
import { TermoReferenciaAditivoService } from '../providers/termo-referencia-aditivo';
import { MonitoramentoDecisoesService } from '../providers/monitoramento-decisoes-service';
import { MateriaisService } from '../providers/materiais-service';
import { OrcamentoService } from '../providers/orcamento-service';
import { TomadaDeContaService } from '../providers/tce-service';
import { ConvenioService } from '../providers/convenio-service';
import { ContratosGestaoService } from '../providers/contratos-gestao-service';

import { RolresponsaveisService } from '../providers/rolresponsaveis-service';

import { LogoutPage } from '../pages/logout/logout';

import { NgPipesModule } from 'ngx-pipes';
import { PipesModule } from '../pipes/pipes.module';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { PopoverAssinantesPage } from "../pages/popovers/popover-assinantes";

import { ModulosController } from '../pages/modulos/modulos-controller';
import { ModalNaoSeAplicaPage } from "../pages/modais/nao-se-aplica/modal-nao-se-aplica";
import { RolAssinantesService } from "../providers/rol-assinantes-service";
import { ArquivoFilterPipe } from "../pipes/filterArquivo";

import { QuillModule } from 'ngx-quill';
import { ModalCertificadoPage } from '../pages/modais/modal-certificado/modal-certificado';

import { NgSelectModule } from "@ng-select/ng-select";
import { ContabilidadeService } from '../providers/contabilidade-service';

import { CertificadoPage } from '../pages/certificado/certificado';
import { AssinaturaModule } from '../assinatura/assinatura.module';
import { AmbienteService } from '../providers/ambiente-service';
import { RequestInterceptor } from './reques.interceptor';
import { PcaInterceptor } from './pca-interceptor';



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    ModalResponsavelTcePage,
    CadastroPerguntasPage,
    TiposIrregularidadesPage,
    ModalAdicionarPerguntaPage,
    ModalDetalhesRolResponsaveisPage,
    ModalListaEvidenciaPage,
    MudaValorPergunta,
    ModalCriaPcaPage,
    ModalOcorrenciaPage,
    ModalPessoaRolPage,
    ModalTiposIrregularidadesPage,
    ModalCadastroPerguntasPage,
    ModalVincularArquivoPage,
    ModalPlanoAcaoPage,
    ModalPreVisualizarControlesInternoPage,
    ModalPreVisualizarProcessosCorrelatosPage,
    ModalProdutoContratoPage,
    ModalTermoReferenciaAditivoPage,
    ModalJustificativaContratoPage,
    LogoutPage,
    ModalCargoPage,
    ModalBensServicosPage,
    ModalPreVisualizarMonitoramentoDecisoesPage,
    ModalDeterminacoesEvidenciasPage,
    ModalPortariasPage,
    ModalPessoalEvidenciasPage,
    ModalPessoalTermoReferenciaPage,
    ModalEditarTextoPage,
    ModalAutuacaoPage,
    ModalPreVisualizarLicitacaoPage,
    ModalPreVisualizarContratosPage,
    ModalArquivosPage,
    ModalContratosPage,
    ModalArquivosContratosPage,
    ModalContratosGestaoPage,
    ModalPagamentosPage,
    ModalContasBancariasPage,
    ModulosController,
    PopoverAssinantesPage,
    AjudaPage,
    ModalServidoresPessoalPage,
    ModalRetificacaoPage,
    ModalNaoSeAplicaPage,
    ModalPreVisualizarPessoalPage,
    ModalPreVisualizarContratosGestaoPage,
    ModalPreVisualizarMateriaisPage,
    ModalPreVisualizarOrcamentoPage,
    ModalPreVisualizarConveniosPage,
    ModalPreVisualizarContabilidadePage,
    ModalPreVisualizarTcePage,
    ModalPessoalVinculadoPage,
    ArquivoFilterPipe,
    ModalCertificadoPage,
    CertificadoPage
  ],
  imports: [
    IonicModule.forRoot(MyApp),
    FormsModule,
    TextMaskModule,
    MenuModule,
    NavBarModule,
    ModulosModule,
    GestaoPCAModule,
    BrowserModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    NgxPaginationModule,
    HttpClientModule,
    OrderModule,
    NgPipesModule,
    AngularFontAwesomeModule,
    CurrencyMaskModule,
    CommonModule,
    FileUploadModule,
    PipesModule,
    QuillModule,
    NgSelectModule,
    NgbModule,
    AssinaturaModule 
  ],
  bootstrap: [
    IonicApp
  ],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    CadastroPerguntasPage,
    TiposIrregularidadesPage,
    ModalResponsavelTcePage,
    ModalPessoaRolPage,
    ModalAdicionarPerguntaPage,
    ModalDetalhesRolResponsaveisPage,
    ModalListaEvidenciaPage,
    ModalCriaPcaPage,
    ModalOcorrenciaPage,
    ModalCadastroPerguntasPage,
    ModalTiposIrregularidadesPage,
    ModalVincularArquivoPage,
    ModalPlanoAcaoPage,
    ModalPreVisualizarControlesInternoPage,
    ModalPreVisualizarProcessosCorrelatosPage,
    ModalProdutoContratoPage,
    ModalTermoReferenciaAditivoPage,
    ModalJustificativaContratoPage,
    LogoutPage,
    ModalCargoPage,
    ModalBensServicosPage,
    ModalPreVisualizarMonitoramentoDecisoesPage,
    ModalDeterminacoesEvidenciasPage,
    ModalPortariasPage,
    ModalPessoalEvidenciasPage,
    ModalPessoalTermoReferenciaPage,
    ModalEditarTextoPage,
    ModalAutuacaoPage,
    ModalPreVisualizarLicitacaoPage,
    ModalPreVisualizarContratosPage,
    ModalArquivosPage,
    ModalContratosPage,
    ModalContratosGestaoPage,
    ModalPagamentosPage,
    ModalContasBancariasPage,
    PopoverAssinantesPage,
    ModulosController,
    AjudaPage,
    ModalServidoresPessoalPage,
    ModalRetificacaoPage,
    ModalNaoSeAplicaPage,
    ModalPreVisualizarPessoalPage,
    ModalPreVisualizarContratosGestaoPage,
    ModalPreVisualizarMateriaisPage,
    ModalPreVisualizarOrcamentoPage,
    ModalPreVisualizarConveniosPage,
    ModalPreVisualizarContabilidadePage,
    ModalPreVisualizarTcePage,
    ModalPessoalVinculadoPage,
    ModalCertificadoPage,
    CertificadoPage
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: PcaInterceptor, multi: true },
    UsuarioService,
    AlertService,
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    },
    AnaliseService,
    UtilService,
    UtilServiceV2,
    FileService,
    TermoReferenciaAditivoService,
    ContratoService,
    RolresponsaveisService,
    MonitoramentoDecisoesService,
    OrcamentoService,
    ArquivosService,
    CertificadoService,
    ContasBancariasService,
    TomadaDeContaService,
    ConvenioService,
    MateriaisService,
    CargoService,
    RolAssinantesService,
    ContabilidadeService,
    ContratosGestaoService,
    AmbienteService
  ]
}
)


export class AppModule {

  constructor() {
  }



}



// WEBPACK FOOTER //
// ./src/app/app.module.ts